import React from 'react';
import { useSelector } from 'react-redux';
import { useUserAccess } from '../../shared/hooks/useUserAccess';
import Client from '../components/Client';
import CustomerSelect from '../components/CustomerSelect';
import ExtensionSelect from '../components/ExtensionSelect';
import UserLevelError from '../components/UserLevelError';
import { StoreState } from '../store';
import Loading from './Loading';

const App: React.FC = () => {
  const {
    accessLevel,
    hasWebRTCEnabledExtensions,
    isRegularUser,
    extensionNotWebRTCEnabled,
  } = useUserAccess();
  const activeCustomerId = useSelector(
    (state: StoreState) => state.client.activeCustomer?.id,
  );
  const loading = useSelector(
    (state: StoreState) =>
      state.client.isFetchingLinkedUsers || state.client.isFetchingExtension,
  );

  const isBrandingInitialized = useSelector(
    (state: StoreState) => state.branding.isInitialized,
  );

  // TODO_V2 handle branding errors

  // TODO spinner or something?
  if (!isBrandingInitialized) {
    return null;
  }

  if (loading) {
    return <Loading />;
  } else if (!isRegularUser) {
    return (
      <UserLevelError title='To use Communicator please log in as a customer or an extension user.' />
    );
  } else if (extensionNotWebRTCEnabled) {
    if (accessLevel === 'CUSTOMER' && hasWebRTCEnabledExtensions) {
      return <ExtensionSelect />;
    } else {
      return (
        <UserLevelError
          title='WebRTC is disabled for this extension'
          description='Please get in touch to have it enabled.'
        />
      );
    }
  } else if (activeCustomerId) {
    return <Client />;
  }
  return <CustomerSelect />;
};

export default App;
